<template>
  <div class="stake-assets">
    <div class="d-flex align-center justify-space-between">
      <div class="text-4">Proof-of-Stake Assets</div>
    </div>
    <div class="mt-6">
      <stake-table :stakeItems="stakeItems" class="d-none d-md-block" />
      <stake-list-mobile :stakeItems="stakeItems" class="d-block d-md-none" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import { projectMapEco } from "@/common/config/ecosystems";
import StakeTable from "./StakeTable.vue";
import StakeListMobile from "./StakeListMobile.vue";

export default {
  components: {
    StakeTable,
    StakeListMobile,
  },
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      ethereumProjects: "projectConfig/ethereumStakingProjects",
      tendermintProjects: "projectConfig/tendermintStakingProjects",
      solanaProjects: "projectConfig/solanaStakingProjects",
      suiStakingProjects: "projectConfig/suiStakingProjects",
      unbondings: "portfolio/unbondings",
      ethereums: "portfolio/ethereums",
      tendermints: "portfolio/tendermints",
      solanas: "portfolio/solanas",
      suis: "portfolio/suis",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
    }),
    stakeItems() {
      const data = [];
      const aum = {
        ...this.ethereums,
        ...this.tendermints,
        ...this.solanas,
        ...this.suis,
      };
      const projects = [
        ...this.ethereumProjects,
        ...this.tendermintProjects,
        ...this.solanaProjects,
        ...this.suiStakingProjects,
      ];
      projects.forEach(item => {
        const tokenPrice = this.getTokenPriceInUsd(item.staking.token);
        const todayAum = aum[item.name]?.staked.balance || 0;
        const yesterdayAum = aum[item.name]?.staked.balance || 0;
        data.push({
          token: item.staking.token,
          tokenName: item.staking.token,
          projectName: item.name,
          name: item.text,
          variesApy: item.variesApy,
          tokenPrice,
          icon:
            (this.$vuetify.theme.dark ? item.logoSmallDark : item.logoSmall) ||
            item.logoSmall,
          totalStakedAUM: new BN(todayAum).multipliedBy(tokenPrice).toNumber(),
          rewards: new BN(aum[item.name]?.rewards.balance || 0)
            .multipliedBy(tokenPrice)
            .toNumber(),
          unbonding: new BN(this.unbondings[item.name] || 0)
            .multipliedBy(tokenPrice)
            .toNumber(),
          balanceChange24h: {
            totalStakedAUM: {
              value: new BN(todayAum)
                .minus(yesterdayAum)
                .multipliedBy(tokenPrice)
                .toNumber(),
              percentage: new BN(todayAum)
                .minus(yesterdayAum)
                .dividedBy(yesterdayAum || 1)
                .multipliedBy(100)
                .toNumber(),
            },
          },
          market: projectMapEco[item.config.network],
        });
      });
      return data;
    },
  },
};
</script>
